import React from 'react'
import WorkImg from '../assets/prospectus_lp.png'
import Empireo from '../assets/empireo-metais.png'
import Destack from '../assets/destack-metais.png'
import praxio from '../assets/logo_praxio.png'
import smsfunnel from '../assets/logo_smsfunnel.png'

const Work = () => {
    return (
        <div name='work' className='w-full md:h-screen text-gray-300 bg-[#0a192f]'>
            <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
                <div className='pb-4'>
                    <p className='text-4xl font-bold inline border-b-4 text-gray-300 border-[#cd853f]'>Projetos</p>
                    <p className='py-4'>Confira abaixo alguns dos projetos que participei ou estou participando no momento!</p>
                </div>
                <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>
                    <div
                        style={{ backgroundImage: `url(${Empireo})`, backgroundSize: 'cover' }}
                        className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'
                    >
                        <div className='opacity-0 group-hover:opacity-100'>
                            <span className='text-2xl font-bold text-white tracking-wider'>
                                Empíreo Metais
                            </span>
                            <div className='pt-8 text-center'>
                                <a href='https://empireometais.com.br/' Target="_blank">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Visitar</button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{ backgroundImage: `url(${Destack})`, backgroundSize: 'contain' }}
                        className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'
                    >
                        <div className='opacity-0 group-hover:opacity-100'>
                            <span className='text-2xl font-bold text-white tracking-wider'>
                                Destack Metais
                            </span>
                            <div className='pt-8 text-center'>
                                <a href='https://destackmetais.com.br/' Target="_blank">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Visitar</button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{ backgroundImage: `url(${WorkImg})`, backgroundSize: 'cover' }}
                        className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'
                    >
                        <div className='opacity-0 group-hover:opacity-100'>
                            <span className='text-2xl font-bold text-white tracking-wider'>
                                (Construindo...)
                            </span>
                            <div className='pt-8 text-center'>
                                <a href='https://prospectusnbn.com.br/' Target="_blank">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Visitar</button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{ backgroundImage: `url(${praxio})`, backgroundSize: 'contain'}}
                        className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'
                    >
                        <div className='opacity-0 group-hover:opacity-100'>
                            <span className='text-2xl font-bold text-white tracking-wider'>
                                Visitar
                            </span>
                            <div className='pt-8 text-center'>
                                <a href='https://praxio.com.br/' Target="_blank">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Visitar</button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{ backgroundImage: `url(${smsfunnel})`, backgroundSize: 'contain' }}
                        className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'
                    >
                        <div className='opacity-0 group-hover:opacity-100'>
                            <span className='text-2xl font-bold text-white tracking-wider'>
                                Visitar
                            </span>
                            <div className='pt-8 text-center'>
                                <a href='https://www.smsfunnel.com.br/' Target="_blank">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Visitar</button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Work